import { MedicationCounterMeasures } from "pokal_api"

const MedicationCounterMeasureNames: Record<MedicationCounterMeasures, string> =
    {
            [MedicationCounterMeasures.DISCONTINUATION_OF_AD_WITHOUT_TAPERING_OFF]:
                "Medikationsänderung: Absetzen ohne Ausschleichen der Dosis",
            [MedicationCounterMeasures.DISCONTINUATION_OF_AD_WITH_TAPERING_OFF]:
                "Medikationsänderung: Absetzen mit Ausschleichen der Dosis",
            [MedicationCounterMeasures.CHANGE_AD]:
                "Medikationsänderung: Wechsel des Arzneistoffs",
            [MedicationCounterMeasures.DOSE_REDUCTION]:
                "Medikationsänderung: Dosisreduktion (kein Absetzen)",
            [MedicationCounterMeasures.DISCONTINUATION_OF_NON_AD_MEDICATION]:
                "Medikationsänderung: Zunächst keine Änderung, Aufnahme in Patientenakte und Beobachtung",
            [MedicationCounterMeasures.DOSE_REDUCTION_OF_NON_AD_MEDICATION]:
                "Medikationsänderung: Zunächst keine Änderung, Patient:innenaufklärung",
            [MedicationCounterMeasures.NO_CHANGE_LAB]:
                "Abklärung: Zunächst keine Änderung, Laboruntersuchung",
            [MedicationCounterMeasures.NO_CHANGE_EKG]:
                "Abklärung: Zunächst keine Änderung, EKG",
            [MedicationCounterMeasures.ELSE]: "Andere Maßnahme ergriffen"
    }

export default MedicationCounterMeasureNames